import React, { useState } from "react"
import { Card, CardBody, Col, Row, Button } from "reactstrap"
import { createImageFromInitials, getRandomColor } from "utils/Utils"
import { encrypt } from "utils/EncryptDecrypt"
import { Link } from "react-router-dom"
import { useEffect } from "react"
import { ConnectionServices } from "utils/ConnectionServices"
import { useSelector } from "react-redux"
import CommonLoader from "common/CommonLoader"
import NoInvitations from "../../Groups/components/NoInvitations"
import { withAlert } from "react-alert"
import { ConnectionService } from "utils/ConnectionService"
import LoadMoreButton from "common/LoadMoreButton/LoadMoreButton"

const PagesFollowed = (props) => {
    const { pages, isLoading, getFollowedPages, alert, currentPage, hasMore, isLoadingMore, setIsLoadingMore } = props;

    const handleUnFollow = (id) => {
        ConnectionService.UnFollowing(id)
            .then((response) => {
                if (response.status === 204) {
                    alert.success("Group unfollowed successfully..");
                    getFollowedPages();
                }
                else {
                    alert.error("Something went wrong...");
                }
            })
        getFollowedPages();
    }

    const fetchData = () => {
        setIsLoadingMore(true);
        getFollowedPages(currentPage + 1);
    };
    return (
        <>
            <div className="card-group nexogic-card-group-list card nexogic-connection-card nexogic-custom-scroll">
                {
                    isLoading ?
                        <Col><div className="text-center"><CommonLoader /></div></Col>
                        :
                        (
                            pages.length > 0
                                ?
                                pages.map((e, ind) => (
                                    <CardBody key={'follow-page-' + ind}>
                                        <div className="row no-gutters">
                                            <div className="col-auto col-img">
                                                <img src={createImageFromInitials(50, e?.institutionProfileInfo?.name, getRandomColor(encrypt(e?.institutionProfileInfo?.guid).toString()))} className="card-img rounded card-img-md" />
                                            </div>
                                            <div className="col col-content-right-btn">
                                                <div className="nexogic-content-details">
                                                    <h3 className="card-title"><Link className="text-decoration-none" to={`/institution/${e.institutionProfileInfo?.profileId}`}>{e.institutionProfileInfo?.name}</Link></h3>
                                                </div>
                                                <div className="nexogic-action-part"><Button color="primary" className="nexogic_primary_button_outline" onClick={() => handleUnFollow(e.id)}>Unfollow page</Button></div>
                                            </div>
                                        </div>
                                    </CardBody>


                                ))
                                :
                                <div className="nexogic-nodata-dotted"><div className="no-suggestion-text text-center"><NoInvitations content={"No Pages"} /></div></div>
                        )
                }
                {hasMore &&
                    <div className="text-center mt-3">
                        {isLoadingMore
                            ?
                            <CommonLoader style={{ width: "2rem", height: "2rem" }} />
                            :
                            <LoadMoreButton loadMore={fetchData} />
                        }
                    </div>
                }
            </div>
        </>
    )
}

export default withAlert()(PagesFollowed)